module.exports = __webpack_public_path__ + "img/halloween-window-21.abb42883.svg";